// 双重（移动端）
<template>
  <div class="cmain">
    <mheader></mheader>
    <div class="topimg"></div>
    <div class="center">
      <h1 class="title">双重预防体系咨询服务</h1>
      <p>包括安全评估及认证服务，双重预防体系实施，双重预防体系建设咨询、双重预防体系建设培训、双重预防体系平台建设以及不同行业、特殊环境双体系定制开发等内容。</p>
      <p>指导企业建立组织机构、完善工作制度，建立健全档案管理制度，风险点排查确定，危险源识别、分析，风险评价，制定风险管控措施；隐患分级与分类，重大隐患治理。</p>

      <h1 class="two">双重预防体系建设思路</h1>
      <p>1.企业根据自身情况成立负责双重预防体系工作的领导小组，健全完善风险分级管控和隐患排查治理制度，对双重预防体系建设所需的相关知识开展分层次、有针对性的人员培训。</p>
      <p>2.进行风险分级管控工作，根据评估结果划分风险等级，制定相应的分级管控措施进行风险分级管控。</p>
      <p>3.根据风险情况做相应的隐患排查治理工作。及时修正发现的问题和偏差，完善安全风险管控制度和隐患治理措施，持续改进提升，不断提高安全管理水平。</p>

      <div class="oneMsg"></div>
      <h1>产品功能</h1>
      <div class="twoMsg"></div>

      <ul class="fenxiList">
        <li class="fengxian">
          <div class="fengxianTitle Title">风险分级管控</div>
          <div class="fengxianImg"></div>
          <p class="xxmsg">① 风险分级管控包括风险点采集，风险源辨识，风险分级管控，风险四色图。</p>
          <p
            class="xxmsg"
          >② 安全检查分为专项检查和日常巡检，公司领导/项目领导可根据企业自身制定的安全管理要求，制定安全检查目标并建立对应的检查任务，保证安全检查任务落实到具体责任人。</p>
          <p class="xxmsg">③ 可在系统中跟踪查询各项目及相关责任人安全检查落实情况，远程快速掌握各项目及相关责任人履职情况。</p>
          <p
            class="xxmsg"
          >④ 针对安全管理中存在的专项检查，现场负责人员可通过手机APP提交专项检查任务，参与人按说明情况检查完成后提交系统。现场负责人员可根据系统来追踪专项检查完成情况，提升协作效率。</p>
        </li>
        <li class="yinhuan">
          <div class="yinhuanTitle Title">隐患排查治理</div>
          <div class="yinhuanImg"></div>
          <p
            class="xxmsg"
          >① 检查人按照隐患排查计划进行隐患排查，排查过程中确认为隐患的，直接推送给责任人及整改人，责任人及整改人收到工作指令后进行隐患整改，整改完成后提交验收申请。若验收不通过，则打回重新进行整改，待整改复查后结束验收流程。</p>
          <p
            class="xxmsg"
          >② WEB端可实时追踪整改进度，超期未验收会上报进行任务督促，验收完成后生成验收记录，验收数据上传云端并提供历史数据备份、数据分析、数据统计等功能。</p>
        </li>
        <li class="anquan">
          <div class="anquanTitle Title">安全教育培训</div>
          <div class="anquanImg"></div>
          <p
            class="xxmsg"
          >通过系统标准化体系的协助流程以及查看系统历史台账等，新人可依据公司安全管理流程及规定动作提交任务，降低了新人的安全教育成本，同时提升了新人的安全方面专业能力。对人员安全教育培训的内容，培训资料，培训考核结果，安全交底等可以记录留痕，让安全教育培训有计划，有标准，有落实，有效益。同时公司体系规范，规章制度，项目资料等可以通过云端存储，让项目人员随时随地接受安全教育和学习。</p>
        </li>
        <li class="shuju">
          <div class="shujuTitle Title">数据分析</div>
          <div class="shujuImg"></div>
          <p class="xxmsg">① 通过对数据分析，能够快速统计隐患排查完成的情况，各类作业风险的比较，隐患整改率，检查类型分析等等信息。</p>
          <p class="xxmsg">② 通过隐患台账的分析，可以快速获取到项目隐患情况，责任人及整改人，整改日期，整改状态，隐患验收等等信息。</p>
        </li>
      </ul>

      <h1>BIM大屏</h1>
      <div class="bimImg"></div>
    </div>
    <div class="lunbo">
      <el-carousel indicator-position="none">
        <el-carousel-item>
          <div class="item">
            <div class="top text-center">
              <p
                style="margin: 0;padding: 0;color: #ffffff;font-weight: bold;font-size: .8rem;text-align: center;line-height: 3rem"
              >风险隐患预防</p>
            </div>
            <div class="bottom">
              <p
                style="text-indent: .5rem; font-size:.6rem"
              >包括风险分级管控体系和隐患排查治理体系，其目的是要把安全生产关口前移，把事故隐患提前消灭掉。系统通过风险源识别、重大安全问题提前预警，对风险点设置监管任务，定时检查，动态展示近期风险源检查的结果，如重大问题未解决则会向经理部、分公司等相关负责人推送通知。</p>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="item">
            <div class="top text-center">
              <p
                style="margin: 0;padding: 0;color: #ffffff;font-weight: bold;font-size: .8rem;text-align: center;line-height: 3rem"
              >建立健全档案制度规范</p>
            </div>
            <div class="bottom">
              <p
                style="text-indent: .5rem; font-size:.6rem"
              >系统将操作流程与双重安全预防体系管理的标准相结合，依据项目进度和验收标准，合理制定安全检查的工作计划，设置标准化风险识别和隐患管控流程规范，每一处风险点都有对应的责任人及检查人进行监督，在实践中与企业安全管理体系相辅相成，可协助企业完善自身安全管理体系。</p>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="item">
            <div class="top text-center">
              <p
                style="margin: 0;padding: 0;color: #ffffff;font-weight: bold;font-size: .8rem;text-align: center;line-height: 3rem"
              >责任明确到人</p>
            </div>
            <div class="bottom">
              <p
                style="text-indent: .5rem; font-size:.6rem"
              >系统中，通过现场责任区域的划分，协作过程中对检查人、整改人的通知提醒以及抄送信息，将不同部门的人员与统一任务管理，明确各方生产责任，集团领可通过系统查看各项目现场真实数据，远程监督各经理部和项目人员。</p>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="item">
            <div class="top text-center">
              <p
                style="margin: 0;padding: 0;color: #ffffff;font-weight: bold;font-size: .8rem;text-align: center;line-height: 3rem"
              >安全教育培训</p>
            </div>
            <div class="bottom">
              <p
                style="text-indent: .5rem; font-size:.6rem"
              >通过系统标准化体系的协助流程以及查看系统历史台账等，新人可依据公司安全管理流程及规定动作提交任务，降低了新人的教育成本，同时提升新人安全方面的专业能力。</p>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="item">
            <div class="top text-center">
              <p
                style="margin: 0;padding: 0;color: #ffffff;font-weight: bold;font-size: .8rem;text-align: center;line-height: 3rem"
              >专项检查</p>
            </div>
            <div class="bottom">
              <p
                style="text-indent: .5rem; font-size:.6rem"
              >集团、公司领导可下发安全专项检查任务。按照分公司、项目部自查、总部督查的原则，对在建工程的危险性较大分部分项工程，重点为深基坑、高大脚手架、高大模板等工程进行全方位、全面检查。检查中发现的隐患，在平台上发起隐患处理流程，跟踪任务进展及落实情况，方便事后责任追溯。</p>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="item">
            <div class="top text-center">
              <p
                style="margin: 0;padding: 0;color: #ffffff;font-weight: bold;font-size: .8rem;text-align: center;line-height: 3rem"
              >风险四色图</p>
            </div>
            <div class="bottom">
              <p
                style="text-indent: .5rem; font-size:.6rem"
              >施工场所、生产设施等区域存在的重大风险、较大风险、一般风险和低风险，分别用红、橙、黄、蓝四种颜色标示在总平面布置图中。各个风险点关联对应的风险等级、责任人及可能导致的事故等信息，管理者可时刻了解项目风险分布状况及动态管理信息。</p>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <mfooter></mfooter>
  </div>
</template>

<script>
import mheader from "../../components/mobileHF/mHeader";
import mfooter from "../../components/mobileHF/mFooter";
export default {
  props: {},
  data() {
    return {};
  },
  mounted() {
    if (this.isMobile()) {
      this.$router.replace("/mDouble"); //移动端跳转路由
    } else {
      this.$router.replace("/double"); //Pc端跳转路由
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  components: {
    mheader,
    mfooter,
  },
};
</script>

<style scoped lang="less">
.lunbo{
  width: 100%;
  height: 20rem;
  background: url('../../assets/img/双重/bj2.jpg') 0 0 no-repeat;
  background-size: 100%;
}
.item .top {
  width: 50%;
  height: 3rem;
  background: url("../../assets/img/双重/5c3c6e18c91123.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 1.8rem auto;
}
.item{
  height: 17rem;
}

.item .bottom {
  width: 60%;
  height: 10rem;
  margin: .5rem auto 0;
  background: url("../../assets/img/双重/5c3c6e18c9112.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #ffffff;
  padding: .5rem;
  p {
    line-height: 1.5;
  }
}



.cmain {
  .topimg {
    width: 100%;
    height: 8.9rem;
    background: url("../../assets/img/mobile/mBanner/双重.png") 0 0 no-repeat;
    background-size: 100%;
  }
  .center {
    width: 100%;
    padding: 0rem 0.6rem;
    box-sizing: border-box;
    overflow: hidden;
    margin-bottom: 1rem;
    h1 {
      opacity: 1;
      font-size: 1rem;
      font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
      font-weight: 700;
      text-align: center;
      color: #4279db;
      line-height: 1.4rem;
      margin: 1rem 0rem;
    }
    p {
      opacity: 1;
      font-size: 0.7rem;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      font-weight: 400;
      text-align: justifyLeft;
      color: #231815;
      line-height: 1rem;
      text-indent: 2em;
      margin-bottom: 0.4rem;
    }
    .two {
      margin-top: 3.41rem;
    }
    .oneMsg {
      height: 27rem;
      opacity: 1;
      background: url("../../assets/img/双重/one.png") 0 0 no-repeat;
      background-size: 100%;
      margin: 1.6rem auto 3rem;
    }
    .twoMsg {
      height: 10.57rem;
      opacity: 1;
      background: url("../../assets/img/双重/two.png") 0 0 no-repeat;
      background-size: 100%;
      margin-bottom: 1.02rem;
    }
    .threeMsg {
      width: 8.83rem;
      height: 4.96rem;
      margin: 0.35rem auto 0.77rem;
      background: url("../../assets/img/双重/图层 2@2x.png") 0 0 no-repeat;
      background-size: 100%;
    }
    .fenxiList {
      padding: 0;
      margin: 0;
      li {
        margin-bottom: 2rem;
        .Title {
          font-size: 0.7rem;
          color: #fff;
          line-height: 1.3rem;
          font-weight: 500;
          padding-left: 3rem;
          box-sizing: border-box;
          margin-bottom: 1.5rem;
        }
        .fengxianTitle {
          width: 10rem;
          height: 1.3rem;
          background: url("../../assets/img/双重/jpg/组3.png") 0 0 no-repeat;
          background-size: 100%;
        }
        .yinhuanTitle {
          width: 10rem;
          height: 1.3rem;
          background: url("../../assets/img/双重/jpg/组3.png") 0 0 no-repeat;
          background-size: 100%;
        }
        .anquanTitle {
          width: 10rem;
          height: 1.3rem;
          background: url("../../assets/img/双重/jpg/组3.png") 0 0 no-repeat;
          background-size: 100%;
        }
        .shujuTitle {
          width: 10rem;
          height: 1.3rem;
          background: url("../../assets/img/双重/jpg/组3.png") 0 0 no-repeat;
          background-size: 100%;
        }
        .fengxianImg {
          width: 100%;
          height: 23rem;
          background: url("../../assets/img/双重/three.png") 0 0 no-repeat;
          background-size: 100%;
          margin-bottom: 1.5rem;
        }
        .yinhuanImg {
          width: 100%;
          height: 24rem;
          background: url("../../assets/img/双重/four.png") 0 0 no-repeat;
          background-size: 100%;
          margin-bottom: 1.5rem;
        }
        .anquanImg {
          width: 100%;
          height: 20rem;
          background: url("../../assets/img/双重/five.png") 0 0 no-repeat;
          background-size: 100%;
          margin-bottom: 1.5rem;
        }
        .shujuImg {
          width: 100%;
          height: 20rem;
          background: url("../../assets/img/双重/six.png") 0 0 no-repeat;
          background-size: 100%;
          margin-bottom: 1.5rem;
        }
      }
    }
    .bimImg {
      width: 100%;
      height: 10rem;
      background: url("../../assets/img/双重/图层 2@3x.png") 0 0 no-repeat;
      background-size: 100%;
      margin-bottom: 1.5rem;
    }
  }
}
</style>
